import React from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';

export default class BoothBuilderDashboard extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of BoothBuilderDashboard
    */
  constructor(props) {
    super(props);
    this.state = {
      expos: []
    }
  }
  /** @method componentWillMount
    * Binds the component to the firebase database expo list
    */
  componentWillMount() {
    this.bindAsArray('/expos', 'expos');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the firebase database
    */
  componentWillUnmount() {
    this.unbind('expos');
  }
  /** @method render
    * Renders the component
    */
  render() {
    // Grab only the booths assigned to this booth builder
    const data = this.state.expos.map(expo => {
      var expoID = expo.id;
      if(!expo.shows) return [];
      return Object.keys(expo.shows).map(showID => {
        var show = expo.shows[showID];
        if(!show.booths) return [];
        return Object.keys(show.booths).filter(boothID => {
          return true && show.booths[boothID].builders && show.booths[boothID].builders[this.props.uid]
        })
        .map(boothID => {
          var booth = show.booths[boothID];
          booth.show = show.metadata.name;
          booth.dataURL = `/expos/${expoID}/shows/${showID}/booths/${boothID}`;
          return booth;
        })
      })
    })
    // Flatten array 1st level
    .reduce((acc, val) => acc.concat(val), [])
    // Flatten array 2nd level
    .reduce((acc, val) => acc.concat(val), [])
    const columns = [
      {Header: "Booth", accessor: "metadata.name"},
      {Header: "Show", accessor: "show"},
      {Header: "Status", accessor: "metadata.status"},
      {Header: "Action", accessor: "dataURL", Cell: (row) => (
        <div style={{textAlign: "center"}}>
          <Link to={row.value}>
            <FontAwesome name="edit"
              style={{color: 'orange'}}
              />
          </Link>
        </div>
      )}
    ]
    return (
      <ReactTable
        className="-striped"
        data={data}
        columns={columns}
        defaultPageSize={15}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/booth-builder-dashboard.js